import script from "./EscrowAccount.vue?vue&type=script&setup=true&lang=ts"
export * from "./EscrowAccount.vue?vue&type=script&setup=true&lang=ts"

import "./EscrowAccount.vue?vue&type=style&index=0&id=2b5aa34b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b5aa34b"]])

export default __exports__